export const REQUEST_SUCCESS_CODE = 200
export const REQUEST_NOAUTH_CODE = 401
export const SMALL_SCREEN_WIDTH = 800

export const TEST_PREP_WELCOME_FLAG = 'TEST_PREP_WELCOME_FLAG'

export const APP_CONFIG_KEY = 'APP_CONFIG'
export const TURNSTILE_KEY = import.meta.env.VITE_TURNSTILE_KEY
export const EMPTY_SIZE = 350

export const MAX_HISTORY_ROUND = 30

export const BUTTON_TEXT = {
    quizMe: 'QUIZME',
    reAnswer: 'REANSWER'
}

// 根据域名判断 APP_NAME
const getAppName = (): string => {
    if (true) {
        const hostname = window.location.hostname

        if (hostname.includes('mysovi-ai')) {
            return 'mysovi.ai'
        }

        if (hostname.includes('sovi-page')) {
            return 'SOVI'
        }
    }

    return 'Sovi.AI'
}

// 根据域名判断 email 地址
const getEmailAddress = (): string => {
    if (true) {
        const hostname = window.location.hostname

        if (hostname == 'sovi.chat') {
            return 'support@sovi.chat'
        }
    }

    return 'support@mysovi.ai'
}

export const APP_NAME = getAppName()
export const EMAIL_ADDRESS = getEmailAddress()

export const TP_QUESTION_COUNT = {
    list: [
        {
            number: 5,
            time: 10
        },
        {
            number: 10,
            time: 20
        },
        {
            number: 15,
            time: 30
        },
        {
            number: 20,
            time: 40
        }
    ],
    defaultNumber: 10
}
